/**
 * Applies per-station brand colors to CSS custom properties on <html>.
 * Every mobile-app UI uses var(--kioo-primary), --kioo-accent, etc.
 * so switching stations instantly re-skins the entire /app/* surface.
 */

import React, { useEffect } from 'react';
import { useKiooAudio } from './AudioProvider';

const DEFAULTS = {
  primary: '#16a34a',
  primary_dark: '#065f46',
  accent: '#22c55e',
  background: '#ecfdf5',
  text_on_primary: '#ffffff',
};

export const StationTheme = ({ children }) => {
  const { currentStation } = useKiooAudio();
  const colors = currentStation?.colors || DEFAULTS;

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--kioo-primary', colors.primary);
    root.style.setProperty('--kioo-primary-dark', colors.primary_dark);
    root.style.setProperty('--kioo-accent', colors.accent);
    root.style.setProperty('--kioo-background', colors.background);
    root.style.setProperty('--kioo-text-on-primary', colors.text_on_primary);

    // Update theme-color meta for the phone's status bar
    let meta = document.querySelector(
      'meta[name="theme-color"][data-mobile-app="true"]'
    );
    if (meta) meta.content = colors.primary;
  }, [colors.primary, colors.primary_dark, colors.accent, colors.background, colors.text_on_primary]);

  return <>{children}</>;
};

export default StationTheme;
